import { ChevronRightIcon } from '@chakra-ui/icons';
import { Box, Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { colors } from 'constants/constants';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { HighlightsProps, NestedHighlight } from 'types/umbraco';

function withLink(
  i: number,
  link: string,
  isExternal: boolean,
  element: JSX.Element
): JSX.Element {
  if (link) {
    if (isExternal) {
      return (
        <a href={link} target="_blank" rel="noopener noreferrer" key={i}>
          {element}
        </a>
      );
    }

    return (
      <Link href={link} key={i}>
        {element}
      </Link>
    );
  }

  return <div key={i}>{element}</div>;
}

export default function HighlightsBlock({
  nestedHighlights,
}: HighlightsProps): JSX.Element {
  // const categories = [];
  // nestedHighlights.forEach((element) =>
  // categories.push(element.kategorier))
  // categories.map((c, i) => {
  //   console.log(c)
  // })

  const [hoverIndex, setHoverIndex] = useState(-1);
  return (
    <Box p={{ base: '2em 5%', md: '5em 5%', xl: '5em 0' }}>
      <Container maxW="7xl">
        {/* {nestedHighlights &&
          nestedHighlights.map((c) => {
          return (
            <h1>{c.kategorier}</h1>

          )
      })} */}

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 3 }} spacing={10}>
          {nestedHighlights &&
            nestedHighlights.items.map((block, i) => {
              const { isExternal, link } = formatLink(block);
              return withLink(
                i,
                link,
                isExternal,
                <Box
                  onMouseEnter={() => setHoverIndex(i)}
                  onMouseLeave={() => setHoverIndex(-1)}
                  key={i}
                  color={colors.black}
                  display="flex"
                  flexDirection="column"
                  height="100%"
                  _hover={{
                    transform: 'translateY(-1.5em)',
                    color: colors.primary[900],
                  }}
                  transition=".15s all ease-in-out">
                  {block.content.properties.highlightImage && (
                    <Box
                      w="100%"
                      h="240px"
                      pos="relative"
                      overflow="hidden"
                      borderRadius="1em">
                      <Image
                        src={`${block.content.properties.highlightImage.url}?width=400`}
                        fill
                        className="highlightObjectFit"
                        priority={true}
                        loading="eager"
                        alt={
                          block.content.properties.highlightImage.altText ??
                          block.content.properties.highlightImage.name
                        }
                      />
                      <style jsx global>{`
                        .highlightObjectFit {
                          object-fit: cover;
                        }
                      `}</style>
                    </Box>
                  )}

                  <Heading
                    mt=".8em"
                    mb=".5em"
                    color="inherit"
                    as="h3"
                    size="md"
                    fontWeight="600">
                    {block.content.properties.highlightHeading}
                  </Heading>
                  <Text color={colors.neutrals[700]}>
                    {block.content.properties.highlightText}
                  </Text>
                  {link && block.content.properties.highlightLinkText && (
                    <Text
                      style={{
                        marginTop: 'auto',
                        textDecoration: 'underline',
                        display: 'flex',
                        alignItems: 'center',
                        transition: '.15s all ease-in-out',
                      }}>
                      {block.content.properties.highlightLinkText}{' '}
                      <ChevronRightIcon
                        h={6}
                        w={6}
                        ml={1}
                        transform={
                          hoverIndex === i
                            ? 'translateX(3rem)'
                            : 'translateX(0)'
                        }
                      />
                    </Text>
                  )}

                  {link && block.content.properties.readMoreButton && (
                    <Text className="linkButton">
                      {block.content.properties.readMoreButton}
                      <style jsx global>{`
                        .linkButton {
                          display: -webkit-inline-flex;
                          font-weight: var(--chakra-fontWeights-semibold);
                          margin-top: 20px;
                          padding: 5px 15px;
                          border-radius: 8px;
                          width: fit-content;
                          background: #ff595e;
                          color: #ffffff;
                          background-color: #f27039;
                        }
                      `}</style>
                    </Text>
                  )}
                </Box>
              );
            })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

function formatLink(
  block: NestedHighlight
): { link: string; isExternal: boolean } {
  const externalLink = block.content.properties.externalLink?.trim();
  const internalLink = block.content.properties.highlightLink?.route.path?.replace(
    '/',
    ''
  );
  const isExternal = !!externalLink?.length;

  return { link: isExternal ? externalLink : internalLink, isExternal };
}
